import { render } from "./FormFooterBanner.vue?vue&type=template&id=65454756&scoped=true"
const script = {}

import "./FormFooterBanner.vue?vue&type=style&index=0&id=65454756&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65454756"]])

export default __exports__